import { defaultWagmiConfig } from '@web3modal/wagmi/react'
import { mainnet, metis } from 'wagmi/chains'
import { http } from 'wagmi'

const projectId = 'cdc705e7053c640265c9e1619ea346c7'

const metadata = {
  name: 'Regret Roulette',
  description: 'A decentralized regret management platform',
  url: typeof window !== 'undefined' ? window.location.origin : 'https://regret-roulette.com',
  icons: ['https://regret-roulette.com/icon.png']
}

// Override the default RPC URL for Metis
const metisWithCustomRPC = {
  ...metis,
  rpcUrls: {
    ...metis.rpcUrls,
    default: { http: ['https://andromeda.metis.io/?owner=1088'] },
    public: { http: ['https://andromeda.metis.io/?owner=1088'] },
  }
}

const chains = [mainnet, metisWithCustomRPC]

const wagmiConfig = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  transports: {
    [metisWithCustomRPC.id]: http('https://andromeda.metis.io/?owner=1088')
  }
})

export { wagmiConfig, chains }
